import React from 'react';
import { Dimensions, StyleSheet } from 'react-native';

import { Box, Text } from '@components/Restyle';

type MemberGroup = 'ACTIVE' | 'PENDING' | 'INVITED' | 'REJECTED';
type Header = { id: MemberGroup; name: string; count: number };

const { width } = Dimensions.get('window');

type MembersSectionHeaderProps = {
  item: Header;
};

export const MembersSectionHeader: React.FC<MembersSectionHeaderProps> = ({
  item,
}) => {
  return (
    <Box style={styles.headerMainContainer}>
      <Box
        flexDirection='row'
        flex={width < 1025 ? 1.1 : 2.7}
        alignSelf='flex-start'
        alignItems='center'>
        <Text color='textSecondary' variant='labelEmphasized' mr='xs'>
          {item.name}
        </Text>
        {item.count > 0 && (
          <Box
            alignItems='center'
            justifyContent='center'
            borderColor='grey02'
            borderWidth={1}
            style={{ borderRadius: 10 }}
            height={20}
            minWidth={20}>
            <Text
              mx='xxxs'
              color='grey04'
              variant={
                width < 1025
                  ? 'labelEmphasizedResponsive'
                  : 'labelTabHeaderText'
              }>
              {item.count}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  headerMainContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    width: '100%',
  },
});
